import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GiftAnimated from '@wix/da-ds/pkg/Icons/GiftAnimated';
import { BiData } from '@wix/da-bi/pkg/events';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../../../../utils/hooks/useRestrictToLoggedIn';
import { useGiftNowAction } from '../../hooks';
import GiftExclusivePopup from './_partials/GiftExclusivePopup';
import s from './GiftButton.scss';
const GiftButton = ({ deviation, adoptableState: { fixedPrice = 0 } })=>{
    const { t } = useTranslation();
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const [isGiftExcusivePopupShown, setIsGiftExclusivePopupShown] = useState(false);
    const showGiftPopup = useCallback(()=>setIsGiftExclusivePopupShown(true), []);
    const [forUserId, setForUserId] = useState(undefined);
    const [onGiftNow, biData] = useGiftNowAction(deviation, {
        purchase_price: fixedPrice
    }, forUserId);
    useEffect(()=>{
        if (forUserId) {
            setForUserId(undefined);
            setIsGiftExclusivePopupShown(false);
            onGiftNow();
        }
    }, [
        forUserId,
        onGiftNow
    ]);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'side-rail-gift'
        }
    }, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        compact: true,
        key: "gift-now",
        priority: "secondary",
        onClick: restrictToLoggedIn(ReferralType.SHOP_ADOPTABLES, showGiftPopup),
        biData: BiData(biData)
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: s['root']
    }, /*#__PURE__*/ React.createElement(FlexItem, null, /*#__PURE__*/ React.createElement(Flex, {
        inline: true,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(GiftAnimated, {
        size: IconSize.MEDIUM,
        className: s['gift-icon']
    }))), /*#__PURE__*/ React.createElement(FlexItem, null, t('sidebar.exclusives.buttons.buyer.gift.label')))), isGiftExcusivePopupShown && /*#__PURE__*/ React.createElement(GiftExclusivePopup, {
        requestClose: ()=>setIsGiftExclusivePopupShown(false),
        onItemClick: (user)=>setForUserId(user.userId)
    }));
};
GiftButton.displayName = 'GiftButton';
export default GiftButton;

//# sourceMappingURL=GiftButton.js.map